



































































































































































































































































import Vue from 'vue';
import {
  brand,
  Brand,
  booth,
  Booth,
  item,
  Item,
  exhibition,
  Exhibition,
  PublicExhibition,
  // firebase,
  analytics,
  FirebaseID,
  // FirestoreDate,
  calender,
} from 'mostra';
import { compact } from 'lodash';

export type BrandInfo = {
  brand: Brand;
  uu: number;
  pv: number;
  checkNum: number;
}

export type BoothInfo = {
  booth: Booth;
  exhibitionId: FirebaseID | null;
  exhibition: PublicExhibition | null;
  uu: number;
  pv: number;
}

export type ItemInfo = {
  item: Item;
  uu: number;
  pv: number;
  checkNum: number;
}

export type ExhibitionInfo = {
  exhibition: Exhibition;
  uu: number;
  pv: number;
}
export type BrandInfoType = {
  id: FirebaseID;
  brandInfo: BrandInfo | null;
  boothInfos: BoothInfo[];
  itemInfos: ItemInfo[];
  exhibitionInfos: ExhibitionInfo[];
};

export type DataType = {
  loading: boolean
  brandInfos: BrandInfoType[]
  owner: string | null,
}
export default Vue.extend({
  name: 'exhibitor-dashboard-analytics',
  data(): DataType {
    return {
      loading: true,
      brandInfos: [],
      owner: null,
    };
  },
  async mounted() {
    try {
      this.loading = true;
      this.$loading(true);
      this.owner = this.$auth.cid;

      const cid = this.$auth.cid;
      if (!cid) throw new Error('cid is null');

      const brands = await brand.loadsByOwner(cid);

      for (const b of brands) {
        if (!b || !b.data.owner || !b.id) {
          throw new Error('Can not find brands');
        }

        const br: BrandInfoType = {
          id: b.id,
          brandInfo: null,
          boothInfos: [],
          itemInfos: [],
          exhibitionInfos: [],
        };

        const bpv = await analytics.calcPVOfBrand(b.id);
        br.brandInfo = {
          brand: b,
          uu: bpv.uu,
          pv: bpv.pv,
          checkNum: bpv.checkNum,
        };

        const bts = await booth.loadsByBrandId(cid, b.id);
        for (const bt of bts) {
          if (!bt.id) throw new Error('Can not bt.id');
          const btpv = await analytics.calcPVOfBooth(b.id, bt.id);
          br.boothInfos.push({
            booth: bt,
            exhibitionId: btpv.exhibitionId,
            exhibition: btpv.exhibition,
            uu: btpv.uu,
            pv: btpv.pv,
          });
        }

        const its = await item.loadsByBrandId(cid, b.id);
        for (const it of its) {
          if (!it.id) throw new Error('Can not it.id');
          const itpv = await analytics.calcPVOfItem(b.id, it.id);
          br.itemInfos.push({
            item: it,
            uu: itpv.uu,
            pv: itpv.pv,
            checkNum: itpv.checkNum,
          });
        }

        const ehs = await exhibition.loadsByBoothIds(compact(bts.map((bi) => bi.id)));
        for (const eh of ehs) {
          if (!eh.id) throw new Error('Can not eh.id');
          const ehpv = await analytics.calcPVOfExhibition(eh.id);
          br.exhibitionInfos.push({
            exhibition: eh,
            uu: ehpv.uu,
            pv: ehpv.pv,
          });
        }

        this.brandInfos.push(br);
      }
    } catch (error: any) {
      this.$fatal(error);
    } finally {
      this.loading = false;
      this.$loading(false);
    }
  },
  methods: {
    formtOpenDate(exh: PublicExhibition | null): string {
      if (!exh) return '-';
      const fdt = calender.formatDateDot(exh.data.fromOpenDate);
      const tdt = calender.formatDateDot(exh.data.toOpenDate);
      return `${fdt} - ${tdt}`;
    },
  },
});
